// extracted by mini-css-extract-plugin
export default {"tooltipDisclaimer":"wBPQ02pXTe","tooltipContainer":"xlPR0Qpzh2","tooltipArrow":"oKiGuF2yGh","tooltipTrigger":"v0PhIJczjn"};